module.exports = __webpack_public_path__ + "img/bucuresti-unirii.1b61163e.jpg";